"use client"

import { Spotlight } from "@/components/ui/Spotlight"
import { useTranslations } from "next-intl"

export function ContactHero() {
  const t = useTranslations("contact.hero")
  
  return (
    <section className="relative w-full pb-8 pt-36">
      {/* Spotlights - full width */}
      <div className="absolute inset-0 overflow-hidden">
        <Spotlight
          className="-top-40 -left-10 md:-left-32 md:-top-20 h-screen"
          fill="white"
        />
        <Spotlight
          className="h-[80vh] w-[50vw] top-10 left-[60%]"
          fill="hsl(168 50% 44%)"
        />
      </div>

      {/* Background grid - full width */}
      <div
        className="absolute inset-0 w-full h-[40vh] dark:bg-background bg-white dark:bg-grid-white/[0.02] bg-grid-black/[0.2]"
      >
        <div
          className="absolute pointer-events-none inset-0 dark:bg-background
          bg-white [mask-image:radial-gradient(ellipse_at_center,transparent_20%,black)]"
        />
      </div>

      {/* Content - centered */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
        <p className="text-accent-primary text-sm font-medium uppercase tracking-widest mb-4">
          {t("sectionLabel")}
        </p>
        
        <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
          {t("title")}
        </h1>
        
        <p className="text-muted-foreground text-lg leading-relaxed">
          {t("subtitle")}
        </p>
        </div>
      </div>
    </section>
  )
}
